import React from 'react';
import Headline from 'headline';
import Button from 'button';
import s from './menu-slide.module.scss';
import { debouncedNavigation } from '../../../../utility';

export default function MenuSlide({ stages, setStage, swiper, gotoContact, isSafari,...props }) {
  return (
    <div className={s.menuSlide}>
      <div className={`${s.content} ${isSafari ? s.safari: ''}`} data-tilt>
        <Headline h2 className={s.headline}>
          <span className={s.one}>START YOUR JOURNEY FROM</span>
          <span className={s.two}>
            SEED TO <br />
            CELEBRATION
          </span>
        </Headline>
        <ul className={s.menu}>
          <Headline h3 className={s.menuTitle}>
            SELECT AN EXHIBIT TO CONTINUE
          </Headline>
          {stages.slice(1, 5).map((el, i) => (
            <li
              key={el}
              className={s.menuItem}
              onClick={() => {
                setStage(i + 1);
                window.highSwiper.slideTo(i + 1);
              }}
            >
              {el}
            </li>
          ))}
          <br />
          {stages.slice(5, 8).map((el, i) => (
            <li
              key={el}
              className={s.menuItem}
              onClick={() => {
                setStage(i + 5);
                window.highSwiper.slideTo(i + 5);
              }}
            >
              {el}
            </li>
          ))}
          <br />
          {stages.slice(8, 9).map((el, i) => (
            <li
              key={el}
              className={s.menuItem}
              onClick={() => {
                setStage(i + 8);
                window.highSwiper.slideTo(i + 8);
              }}
            >
              {el}
            </li>
          ))}
          <li
            className={s.menuItem}
            onClick={() => {
              setStage(9);
              window.highSwiper.slideTo(9);
            }}
          >
            {stages.slice(9)[0]}
          </li>
        </ul>
      </div>
      <div className={s.buttonWrapper}>
        <Button className={s.button} onClick={() => { debouncedNavigation('#contact'); }}>VISIT CANNABITION</Button>
      </div>
    </div>
  );
}
